(ns splash.ui.lender-portal.optimizely
  (:require
    ["@optimizely/react-sdk" :as react-sdk]
    [reagent.core :as r]))

(defn Optimizely
  [sdk-key]
  (react-sdk/createInstance #js{:sdkKey sdk-key}))

(defn optimizelyProvider
  [client user component]
  [(r/adapt-react-class react-sdk/OptimizelyProvider)
   {:optimizely client
    :user       {:id         user
                 :attributes {:username user}}}
   component])

(defn isFeatureEnabled-for-component
  [feature-flag component & [default-component]]
  [(r/adapt-react-class react-sdk/OptimizelyFeature)
   {:feature    feature-flag
    :autoUpdate true}
   (fn [enabled?]
     (if enabled?
       (r/as-element component)
       (r/as-element default-component)))])
